import { render, staticRenderFns } from "./dashBoardAdd.vue?vue&type=template&id=be789486&"
import script from "./dashBoardAdd.vue?vue&type=script&lang=js&"
export * from "./dashBoardAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports